import React from "react";
import Sale from "../../../../utilities/data/model/Sale";

export type CreateQuoteRootScreenContextType = {
  // A valid sale that can be used to create a quote
  sale: Sale;
};

export const CreateQuoteRootScreenContext = React.createContext<
  CreateQuoteRootScreenContextType | undefined
>(undefined);
